import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import BackButton from "../common/back_button";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
// import the sign in function from the actioncreator file
import {
  signInFunction,
  userGoogleAuth,
  userLinkedinAuth,
  clearLogin,
  login_failed,
  login_loading,
  savelink
} from "../../Redux/ActionCreator";
import useMediaQuery from "@mui/material/useMediaQuery";
import HelmetProvide from "../common/helmet";
import { baseURL1 } from '../../Redux/baseURL';
import TranslateButton from "../translate_btn";
// import analytics from "analytics"
import { useAnalytics } from "../../context/AnalyticsContext";
import FormLogin from "../common/login_form";
import HomeButton from "../common/HomeButton/homeButton";
import { useSearchParams } from 'react-router-dom';
import { motion, AnimatePresence } from "framer-motion";
import { Mail, Phone, Eye, EyeOff, X, User } from 'lucide-react';


const Login = () => {
  const [ searchParams, setSearchParams ] = useSearchParams();
  const analytics = useAnalytics();
  const navigate = useNavigate();
  // initialize the useDispatch hook
  const dispatch = useDispatch();
  const theme = useTheme();
  const [checked1, setChecked1] = React.useState(true);
  const [checked2, setChecked2] = React.useState(false);
  const [hide, setHide] = useState(true);
  
  // Recent account modal state
  const [showRecentAccountModal, setShowRecentAccountModal] = useState(false);
  const [recentAccount, setRecentAccount] = useState(null);
  const [showPasswordForRecent, setShowPasswordForRecent] = useState(false);
  const [recentPassword, setRecentPassword] = useState("");
  const [passwordView, setPasswordView] = useState(false);
  
  // create a state to handle the form value
  let pageLang = searchParams.get("lg");
  
  const queryParams = new URLSearchParams(location.search);
  const [cred, setCred] = useState({ username: "", password: "", AcctType: "Client" });

  const login_status = useSelector((stat) => stat.login);
  const CVDetails = useSelector((details) => details.generateCV);
  const details = [CVDetails.message];
  // console.log("details", details);
  const account_stat = new URLSearchParams(window.location.search).get("auth");
  const account_profile_stat = new URLSearchParams(window.location.search).get("p");
  const user_unique_link = new URLSearchParams(window.location.search).get('link');

  // Helper function to read cookie
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      try {
        return JSON.parse(decodeURIComponent(parts.pop().split(';').shift()));
      } catch (e) {
        return null;
      }
    }
    return null;
  };

  // Handle continuing with recent account
  const handleContinueWithRecentAccount = () => {
    if (recentAccount.authMethod === "OAUTH") {
      // For OAuth, trigger Google sign-in directly
      setShowRecentAccountModal(false);
      googleLogin();
    } else {
      // For password auth, show password field
      setShowPasswordForRecent(true);
    }
  };

  // Handle sign-in with recent account and password
  const handleSignInWithRecentAccount = () => {
    if (recentPassword.trim()) {
      // Set the credentials and trigger sign-in
      let cred = {
        username: recentAccount.email,
        password: recentPassword,
        AcctType: "Client"
      }
      dispatch(signInFunction(cred));
      setShowRecentAccountModal(false);
    }
  };

  // Handle dismissing the modal
  const handleDismissModal = () => {
    setShowRecentAccountModal(false);
    setShowPasswordForRecent(false);
    setRecentPassword("");
  };

  // Handle password view toggle
  const handlePasswordView = () => {
    setPasswordView(!passwordView);
  };

  // Google login function
  const googleLogin = () => {
    dispatch(userGoogleAuth());
  };

  useEffect(() => {
    dispatch(clearLogin());
    if (queryParams.get('ref') !== null) {
      localStorage.clear();
      localStorage.setItem("ref", queryParams.get('ref'));
    } else {
      let ref = localStorage.getItem("ref");
      localStorage.clear();
      localStorage.setItem("ref", ref);
    }
    if (user_unique_link !== null) {
      dispatch(savelink(baseURL1 + user_unique_link));
    }
  }, []);

  useEffect(() => {
    const savedCreds = getCookie('moil_user_creds');
    if (savedCreds && savedCreds.email) {
      setRecentAccount(savedCreds);
      setShowRecentAccountModal(true);
    }
  }, []);

  useEffect(() => {
    if (account_stat === "officialAcct") {
      setTimeout(() => {
        toast.error("This account have been registered as an official account.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }, 50);
      // dispatch(
      //   login_failed(
      //     "This account have been registered as an official account."
      //   )
      // );

      dispatch(login_loading());
    } else if (account_profile_stat === "present") {
      setTimeout(() => {
        toast.error(
          "This email already has a client profile but no base account. Please contact support or sign in with the original account.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      }, 50);
      dispatch(login_loading());
    }


    if (login_status.errMess !== null) {
      setTimeout(() => {
        toast.error(login_status.errMess, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }, 50);

      dispatch(login_loading());
    }
    if (login_status.message !== null) {
      setTimeout(() => {
        toast.success(login_status.message?.status, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }, 50);

      dispatch(login_loading());
    }
  }, [account_stat, account_profile_stat, login_status.errMess, login_status.message]);

  const handleChange = (type) => {
    // console.log("cheked");
    if (type == 1) {
      setChecked2(false);
      setChecked1(true);
    } else {
      setChecked1(false);
      setChecked2(true);
    }
  };

  // submit function
  const handleSubmit = () => {
    if (cred.username === "") {
      setTimeout(() => {
        toast.error("Username is required", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }, 50);
    } else if (cred.password === "") {
      setTimeout(() => {
        toast.error("Password is required", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }, 50);
    } else {
      dispatch(signInFunction(cred));
      analytics.track("Login", {
        Type: "Employee login",
        time: new Date(),
        Email: cred.username
      });
      setCred((prev) => ({ ...prev, username: "", password: "", AcctType: "Client" }));
    }
  };

  // const handleSubmitOnManom = async () => {
  //   fetch("https://manomsolutions.com/api/users/me", {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2Njc5NjdiNmRmZjlhNTM1NDY3YjE3NmMiLCJuYW1lIjoiQWRlbGVrZSIsInJvbGVzIjpbInVzZXIiXSwiZW1haWwiOiJhZGVsZWtldDA0MkBnbWFpbC5jb20iLCJpYXQiOjE3MjAyNTg0NjAsImV4cCI6MTcyMDI2MjA2MH0.yOgpnK7I-c4Ce4blTE5UbeiJMNGP4xtuiCpB_UanDPQ"
  //     },
  //   }).then(resp => resp.json())
  //   .then(resp => {
  //     console.log("resp", resp);    
  //   }).catch(err => console.log(err));
  // }

  const screenheight = window.innerHeight;

  const heighting = screenheight >= 755 ? "md:top-[50%] md:translate-y-[-50%]" : "md:top-[35px]";

  return (
    <>
      <HelmetProvide
        title="Moil | Resume Builder Tool"
        description="At Moil, our goal is to help blue-collar workers build resumes and portfolios and connect them to recruiters on our platform."
        className="notranslate"
      />

      <div className="h-screen relative max-w-[100vw] overflow-x-hidden">
        <div className={`absolute z-10 ${heighting} w-full gap-x-4 gap-y-4 justify-center lg:max-w-[876px] xl:max-w-[1024px] left-[50%] translate-x-[-50%] top-[80px] flex lg:gap-x-0 lg:justify-between flex-col md:flex-row items-center px-4`}>
          <div className="w-full">
            <HomeButton className="bg-white p-4 vsm:mb-4 md:mb-0" path="https://moilapp.com" text="homepage" />
            <div className="md:flex md:items-center md:justify-between w-full">
              <p className="text-white font-poppins text-[24px] md:text-[32px] font-bold leading-[30px] md:leading-[36px] tracking-normal flex flex-col gap-y-10 max-w-[380px]">Opportunities are
              waiting for you!
              <span className="font-poppins text-[14px] md:text-[24px] font-[500] leading-[18px] md:leading-[21px] tracking-normal vsm:mb-4 md:mb-0"> Log in now to explore them
              </span></p>
              <FormLogin type="employee" handleSubmit={handleSubmit} username={cred.username} password={cred.password} setCred={setCred} googleLogin={() => dispatch(userGoogleAuth())} lg={pageLang} />
            </div>
          </div>
        </div>


        <div className={`w-full h-added-25 ${screenheight > 755 ? "md:h-full " : "md:h-added-35"} grid custom-grid`}>

          <img src="https://res.cloudinary.com/drlcisipo/image/upload/v1709257428/Website%20images/login-employee_hmhhry.svg" className="w-full md:max-h-max md:h-full object-cover" /> {/* max-h-[340px] */}

          <div className="relative h-full overflow-hidden -z-1000">
            <svg width="851" height="851" viewBox="0 0 1028 992" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute top-[-30%] right-[-30%] -z-10">
              <g opacity="0.1" filter="url(#filter0_f_3436_5351)">
                <circle cx="739.5" cy="252.5" r="425.5" fill="#777DEA" />
              </g>
              <defs>
                <filter id="filter0_f_3436_5351" x="0" y="-487" width="1479" height="1479" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feGaussianBlur stdDeviation="157" result="effect1_foregroundBlur_3436_5351" />
                </filter>
              </defs>
            </svg>

            <svg width="1065" height="1065" viewBox="0 0 1201 1024" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute bottom-[-25%] right-[-20%] -z-10">
              <g opacity="0.1" filter="url(#filter0_f_3436_5429)">
                <circle cx="847.5" cy="695.5" r="533.5" fill="#FF6633" />
              </g>
              <defs>
                <filter id="filter0_f_3436_5429" x="0" y="-152" width="1695" height="1695" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feGaussianBlur stdDeviation="157" result="effect1_foregroundBlur_3436_5429" />
                </filter>
              </defs>
            </svg>
          </div>
        </div>
        <div className="hidden">
          <TranslateButton lg={pageLang} />
        </div>
      </div>

      {/* Recent Account Modal */}
      <AnimatePresence>
        {showRecentAccountModal && recentAccount && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            onClick={handleDismissModal}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="bg-white rounded-2xl p-6 max-w-md w-full mx-4 relative"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={handleDismissModal}
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
              >
                <X size={20} />
              </button>

              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  {recentAccount.userImage ? (
                    <img
                      src={recentAccount.userImage}
                      alt="Profile"
                      className="w-full h-full rounded-full object-cover"
                    />
                  ) : (
                    <User size={32} className="text-blue-600" />
                  )}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Welcome back!
                </h3>
                <p className="text-gray-600 text-sm">
                  Continue with your recent account
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-4 mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                    {recentAccount.authMethod === "OAUTH" ? (
                      <svg width="20" height="20" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.8892 6.53037C20.0605 6.53037 22.1998 7.90025 23.4195 9.04494L28.186 4.39111C25.2585 1.67012 21.4492 0 16.8892 0C10.2837 0 4.57904 3.79062 1.80176 9.30766L7.2625 13.5486C8.63238 9.47654 12.423 6.53037 16.8892 6.53037Z" fill="#EA4335" />
                        <path d="M33.102 17.2644C33.102 15.8758 32.9894 14.8624 32.7455 13.8116H16.8887V20.0792H26.1963C26.0087 21.6368 24.9953 23.9824 22.7435 25.5587L28.0729 29.6871C31.263 26.741 33.102 22.4062 33.102 17.2644Z" fill="#4285F4" />
                        <path d="M7.28099 20.229C6.92444 19.1782 6.71803 18.0522 6.71803 16.8888C6.71803 15.7253 6.92445 14.5994 7.26222 13.5485L1.80148 9.30756C0.65679 11.5969 0 14.1678 0 16.8888C0 19.6098 0.65679 22.1806 1.80148 24.47L7.28099 20.229Z" fill="#FBBC05" />
                        <path d="M16.889 33.7777C21.449 33.7777 25.2771 32.2765 28.0732 29.6868L22.7438 25.5584C21.3176 26.553 19.4035 27.2473 16.889 27.2473C12.4228 27.2473 8.63216 24.3012 7.28105 20.2291L1.82031 24.4701C4.5976 29.9871 10.2835 33.7777 16.889 33.7777Z" fill="#34A853" />
                      </svg>
                    ) : recentAccount.email && recentAccount.email.includes('@') && recentAccount.authMethod === "PASSWORD" ? (
                      <Mail size={16} className="text-blue-600" />
                    ) : (
                      <Phone size={16} className="text-orange-600" />
                    )}
                  </div>
                  <div className="flex-1">
                    <p className="font-medium text-gray-900">
                      {recentAccount.email && recentAccount.email.includes('@') ? recentAccount.email : recentAccount.phone}
                    </p>
                    <p className="text-sm text-gray-500">
                      {recentAccount.authMethod === "OAUTH" ? "Google Account" :
                        recentAccount.email && recentAccount.email.includes('@') ? "Email Account" : "Phone Account"}
                    </p>
                  </div>
                </div>
              </div>

              {!showPasswordForRecent ? (
                <div className="space-y-3">
                  <button
                    onClick={handleContinueWithRecentAccount}
                    className="w-full py-3 px-4 bg-[#5843BD] text-white font-medium rounded-lg hover:bg-[#4a3a9f] transition-colors"
                  >
                    {recentAccount.authMethod === "OAUTH" ? "Continue with Google" : "Continue"}
                  </button>
                  <button
                    onClick={handleDismissModal}
                    className="w-full py-3 px-4 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    Use different account
                  </button>
                </div>
              ) : (
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Enter your password
                    </label>
                    <div className="relative">
                      <input
                        type={passwordView ? "text" : "password"}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#5843BD] focus:border-[#5843BD]"
                        placeholder="Enter your password"
                        value={recentPassword}
                        onChange={(e) => setRecentPassword(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleSignInWithRecentAccount()}
                        autoFocus
                      />
                      <button
                        type="button"
                        onClick={handlePasswordView}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                      >
                        {passwordView ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <button
                      onClick={handleSignInWithRecentAccount}
                      disabled={!recentPassword.trim()}
                      className="w-full py-3 px-4 bg-[#5843BD] text-white font-medium rounded-lg hover:bg-[#4a3a9f] transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
                    >
                      Sign In
                    </button>
                    <button
                      onClick={() => setShowPasswordForRecent(false)}
                      className="w-full py-3 px-4 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      Back
                    </button>
                  </div>
                </div>
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      <ToastContainer />
    </>
  );
};

export default Login;
